export const FIELDS = {
  STEPS: {
    BUYER_INFO_TOGGLER: 'Do you want to Add extra Buyer info fields to your product?',
  }
};
